'use strict';

import injector from 'vue-inject';
import axios from 'axios';

class ImgurApi {
	constructor(){
		this.clientID = process.env.VUE_APP_IMGUR_CLIENT_ID;

		this.baseURL = 'https://api.imgur.com/3/album/rkCIq3S/images'
		// this.baseURL = 'https://api.imgur.com/3/album/kpIYL/images'

		this.imgTotal = [];	//Image objects
		this.imgActual = []; //Index of images to load (padded with placeholder imgs)
		this.imgUrlsTotal = []; //Url strings for vue-gallery component to lazily load imgs

		this.loaded = false;

		this.buffer = 40;

	}

	setDom(dom){
		this.dom = dom;
	}

	getDom(){
		return this.dom;
	}

	getNewGroup(){
		let promise = new Promise((resolve, reject) => {		
			if(!this.loaded){reject("loading");}

			let nextItems = [];
			let dom = this.dom;

			// Selection
			let max = this.imgTotal.length - this.buffer;
			let randomIdx = Math.floor(Math.random() * max);
			if (this.imgTotal.length > 0){
				nextItems = this.imgTotal.slice(randomIdx,randomIdx+this.buffer);
			}
				
			for (let i = 0 ; i <= nextItems.length-1 ; i++) {
				let img = nextItems[i];
				// Scaling
				if(dom && dom.galleryWrapper){
					let minRatioW = dom.galleryWrapper.clientWidth*.45;
					let minRatioH = dom.galleryWrapper.clientHeight*.45;				
					let ratio = Math.min(minRatioW/img.width, minRatioH/img.height);
					img.scaledWidth = img.width*ratio;
					img.scaledHeight = img.height*ratio;
				}

				img.key = randomIdx+i;
			}

			this.imgActual = nextItems;

			resolve(nextItems);
		});
		return promise;
	}

	getAlbum(){
		let promise = new Promise((resolve, reject) => {
			axios.get(this.baseURL, { headers:{Authorization: "Client-ID " + this.clientID} })
				.then(response => {
					this.imgTotal = response.data.data;
					this.shuffle();	// Randomize urls
					this.loaded = true;
					resolve();
				})
				.catch(() => { reject(); });
		});

		return promise;
	}

	shuffle(){
		let array = this.imgTotal;
		for (let i = array.length - 1; i >= 0; i--) {
			let j = Math.floor(Math.random() * (i + 1));
			[array[i], array[j]] = [array[j], array[i]];
			this.imgUrlsTotal.unshift(array[i].link);
		}
	}


	///// Save this for another time
	// followMouse(e){
	// 	let grid = this.dom.grid;
	// 	if (grid === null){
	// 		return;
	// 	}
	// 	let edgeSize = this.edgeSize;
	// 	let timer = this.timer;

	// 	let viewportX = e.clientX;
	// 	let viewportY = e.clientY;

	// 	let viewWidth = this.$refs.grid.clientWidth;
	// 	let viewHeight = this.$refs.grid.clientHeight;

	// 	let edgeTop = this.edgeSize;
	// 	let edgeLeft = this.edgeSize;
	// 	let edgeBottom = viewHeight-this.edgeSize;
	// 	let edgeRight = viewWidth-this.edgeSize;

	// 	let isInLeftEdge = ( viewportX < edgeLeft );
	// 	let isInRightEdge = ( viewportX > edgeRight );
	// 	let isInTopEdge = ( viewportY < edgeTop );
	// 	let isInBottomEdge = ( viewportY > edgeBottom );

	// 	if ( ! ( isInLeftEdge || isInRightEdge || isInTopEdge || isInBottomEdge ) ) {
	// 		clearTimeout( timer );
	// 		return;
	// 	}

	// 	let documentWidth = Math.max(
	// 		grid.scrollWidth,
	// 		grid.offsetWidth,
	// 		grid.clientWidth
	// 	);
	// 	let documentHeight = Math.max(
	// 		grid.scrollHeight,
	// 		grid.offsetHeight,
	// 		grid.clientHeight
	// 	);

	// 	let maxScrollX = ( documentWidth - viewportX );
	// 	let maxScrollY = ( documentHeight - viewportY );

	// 		function adjustWindowScroll(){
	// 			// Get the current scroll position of the document.
	// 			let currentScrollX = grid.scrollLeft;
	// 			let currentScrollY = grid.scrollTop;

	// 			// Determine if the window can be scrolled in any particular direction.
	// 			let canScrollUp = ( currentScrollY > 0 );
	// 			let canScrollDown = ( currentScrollY < maxScrollY );
	// 			let canScrollLeft = ( currentScrollX > 0 );
	// 			let canScrollRight = ( currentScrollX < maxScrollX );

	// 			// Since we can potentially scroll in two directions at the same time,
	// 			// let's keep track of the next scroll, starting with the current scroll.
	// 			// Each of these values can then be adjusted independently in the logic
	// 			// below.
	// 			let nextScrollX = currentScrollX;
	// 			let nextScrollY = currentScrollY;

	// 			// As we examine the mouse position within the edge, we want to make the
	// 			// incremental scroll changes more "intense" the closer that the user
	// 			// gets the viewport edge. As such, we'll calculate the percentage that
	// 			// the user has made it "through the edge" when calculating the delta.
	// 			// Then, that use that percentage to back-off from the "max" step value.
	// 			let maxStep = 50;

	// 			// Should we scroll left?
	// 			if ( isInLeftEdge && canScrollLeft ) {
	// 				let intensity = ( ( edgeLeft - viewportX ) / edgeSize );
	// 				nextScrollX = ( nextScrollX - ( maxStep * intensity ) );
	// 			// Should we scroll right?
	// 			} 
	// 			else if ( isInRightEdge && canScrollRight ) {
	// 				let intensity = ( ( viewportX - edgeRight ) / edgeSize );
	// 				nextScrollX = ( nextScrollX + ( maxStep * intensity ) );
	// 			}
	// 			// Should we scroll up?
	// 			if ( isInTopEdge && canScrollUp ) {
	// 				let intensity = ( ( edgeTop - viewportY ) / edgeSize );
	// 				nextScrollY = ( nextScrollY - ( maxStep * intensity ) );
	// 			} 
	// 			// Should we scroll down?
	// 			else if ( isInBottomEdge && canScrollDown ) {
	// 				var intensity = ( ( viewportY - edgeBottom ) / edgeSize );
	// 				nextScrollY = ( nextScrollY + ( maxStep * intensity ) );
	// 			}

	// 			// Sanitize invalid maximums. An invalid scroll offset won't break the
	// 			// subsequent .scrollTo() call; however, it will make it harder to
	// 			// determine if the .scrollTo() method should have been called in the
	// 			// first place.
	// 			nextScrollX = Math.max( 0, Math.min( maxScrollX, nextScrollX ) );
	// 			nextScrollY = Math.max( 0, Math.min( maxScrollY, nextScrollY ) );

	// 			if (
	// 				( nextScrollX !== currentScrollX ) ||
	// 				( nextScrollY !== currentScrollY )
	// 				) {
	// 				grid.scrollLeft = nextScrollX;
	// 				grid.scrollTop = nextScrollY;
	// 				return( true );
	// 			} 
	// 			else {
	// 				return( false );
	// 			}
	// 		}
	// 	while(adjustWindowScroll()){
	// 		continue;
	// 	}
	// }
}

injector.service('imgurApi', ImgurApi);
